/*
* Pipeline Theme — assets/custom.js
*
* Sundari customisations. This is the theme's OWN documented extension point
* (see the comment block near the bottom of layout/theme.liquid). Nothing in
* theme.js, theme.css or any theme setting is modified — this file only adds
* behaviour on top, so a theme update cannot be broken by it and reverting is
* a one-line change.
*
* The theme ships this file full of example console.log listeners that fire on
* every scroll and resize. Those examples are intentionally NOT kept here — they
* would spam the console of a live storefront. Original preserved at
* theme_backup/custom.js.BEFORE.
*
* --------------------------------------------------------------------------
* 1. QUICKVIEW: open with the variant options already expanded  (27 Aug 2026)
* --------------------------------------------------------------------------
* Tapping the cart icon on a collection card opens the quickview drawer. On
* MOBILE ONLY the theme collapses the colour/size pickers behind a "SHOW
* OPTIONS" button, so a shopper has to tap twice before they can choose a
* variant. Desktop already opens expanded.
*
* Cause, in assets/theme.js, productForm().init():
*     showForm: true                           <- component default
*     ...
*     if (mobile) { this.showForm = false; }   <- mobile-only collapse
*
* Fix: when the options wrapper is collapsed for the first time after a
* quickview renders, click the theme's OWN toggle button. We drive the theme's
* real state transition rather than forcing CSS or poking Alpine internals, so
* the button label, transition and accessibility state all stay correct — it
* simply starts on "HIDE OPTIONS" instead of "SHOW OPTIONS".
*
* One-shot per drawer SESSION: if the shopper then chooses to collapse the
* options themselves, we leave it collapsed. We never fight the shopper.
*
* The drawer reuses its DOM between products (the section is marked
* data-morph-children-only), so the one-shot marker survives a close/reopen and
* would leave every product after the first collapsed. The marker is therefore
* cleared on both edges of a session: when a Quick view button is pressed, and
* on the theme's own 'theme:quickview:close' event.
*/

(function () {
  'use strict';

  var WRAPPER = '[data-quickview-form-area]';
  var TOGGLE = '[data-toggle-button]';
  var FLAG = 'sundariAutoExpanded';

  function autoExpand(wrapper) {
    // Already handled this rendered drawer — a later collapse is the shopper's choice.
    if (wrapper.dataset[FLAG]) return;
    wrapper.dataset[FLAG] = '1';
    var scope = wrapper.closest('.product__form__outer') || wrapper.parentElement;
    var toggle = scope && scope.querySelector(TOGGLE);
    if (toggle) toggle.click();
  }

  function scan() {
    var wrappers = document.querySelectorAll(WRAPPER);
    for (var i = 0; i < wrappers.length; i++) {
      if (!wrappers[i].classList.contains('is-expanded')) autoExpand(wrappers[i]);
    }
  }

  // Coalesce bursts of mutations into a single scan.
  // Deliberately setTimeout and NOT requestAnimationFrame: rAF is suspended while the
  // tab is hidden, so a drawer opened in a background tab would stay collapsed until
  // the tab was focused. A timer runs regardless of visibility.
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 0);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // Start a fresh session: forget that we already auto-expanded a previous product.
  function resetSession() {
    var wrappers = document.querySelectorAll(WRAPPER);
    for (var i = 0; i < wrappers.length; i++) delete wrappers[i].dataset[FLAG];
    schedule();
  }

  // Opening edge. [data-quickview-holder] is the wrapper the theme puts around every
  // Quick view button — used instead of the button's aria-label, which is translated.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-quickview-holder]')) resetSession();
  }, true);

  // Closing edge, via the theme's own event.
  document.addEventListener('theme:quickview:close', resetSession);

  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();
